import React from "react";
import { useRental } from "../../../../contexts/api/rental";
import type {
  RentalModelPricing,
  RentalModelPricingUpdate,
} from "../../../../api/rental/Rental.typed";

export default function useRentalModelPricing() {
  const { listRentalModelPricing, updateRentalModelPricing } = useRental();
  const [rows, setRows] = React.useState<RentalModelPricing[]>([]);
  const [loading, setLoading] = React.useState(true);

  const reload = React.useCallback(async () => {
    setLoading(true);
    const data = await listRentalModelPricing();
    if (data) setRows(data);
    setLoading(false);
  }, [listRentalModelPricing]);

  React.useEffect(() => {
    reload();
  }, [reload]);

  const save = React.useCallback(
    async (modelID: number, payload: RentalModelPricingUpdate) => {
      const ok = await updateRentalModelPricing(modelID, payload);
      if (ok) {
        setRows((prev) =>
          prev.map((r) =>
            r.model_id === modelID
              ? {
                  ...r,
                  is_rentable_per_unit: payload.is_rentable_per_unit ?? r.is_rentable_per_unit,
                  rental_price_ht: payload.rental_price_ht ?? null,
                  rental_tax_rate: payload.rental_tax_rate ?? null,
                  rental_currency: payload.rental_currency ?? null,
                }
              : r,
          ),
        );
      }
      return ok;
    },
    [updateRentalModelPricing],
  );

  return { rows, loading, reload, save };
}
